import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import placeholderImg from '../images/pro-plan.png';
import foodBaner from '../images/food-banner.png';
const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch('https://petcrew.in/app-admin/api/products.php?type=all&page=1');
        const data = await res.json();
        console.log('Fetched Data:', data);

        if (data.Error === 'false' && Array.isArray(data.Data)) {
          setProducts(data.Data);
        } else {
          throw new Error(data.Message || 'Failed to load products.');
        }
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <p className="text-center my-5">Loading products...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <>
      <Helmet>
      <title>Pet Food & Nutrition | Best Food for Your Dog & Cat</title>
  <meta name="description" content="Buy quality pet food from trusted brands. Balanced nutrition for dogs and cats of all breeds and sizes – delivered to your doorstep." />
  <meta name="keywords" content="pet food, dog food, cat food, pet nutrition, pet food delivery, healthy pet diet" />

      </Helmet>

      <Header />
      <div className="container product-listing py-4">
        <div className="row">

        <div className="text-white food-banner">
              <img
                src={foodBaner}
                className="card-img"
                alt="Featured Article"
              />
            </div>
          {products.map((product, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
              <div className="card h-100 shadow-sm product-cards">
                <div className="position-relative">
                  <img
                    src={product.image_link || placeholderImg}
                    className="card-img-top p-3"
                    alt={product.title}
                  />
                </div>
                <div className="card-body">
                  <h6 className="card-title">{product.title}</h6>
                  <p className="mb-1 text-danger fw-bold fs-5">
                    ₹{Number(product.sell_price).toLocaleString()}
                  </p>
                  <p className="text-muted small mb-1">
                    <del>₹{Number(product.mrp_price).toLocaleString()}</del> &nbsp;
                    <span className="text-success">{product.discount_percent}% off</span>
                  </p>
                  <p className="small text-muted">{product.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllProducts;
